export const CLOSE_BANNER = {}

export const countUp = () => {
  return {
    type: "CLOSE_BANNER"
  }
}

export const closeBanner = (id) => {
  return {
    type: CLOSE_BANNER,
    id
  }
}

export default {
  countUp,
  closeBanner
}
